<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      {{ $auth.user().name }}

    </template>\
    <template slot="dropdown">
      <b-dropdown-item v-on:click="logout()"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import router from '@/router'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout() {
      this.$auth.logout()
      router.push({ name: 'login' })
    }
  }
}
</script>
